import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {ArticleService} from '@iw-shop/article/services/article.service';
import {ConfigService} from '@iw-shop/config/service/config.service';
import {GlobalState} from '@store/state/global.state';
import {ApiArticlesGetRequest} from '@api/articles';
import {setDynamicPageLinks, setGroups} from '@store/actions/global.actions';
import {take} from 'rxjs/operators';
import {lastValueFrom} from 'rxjs';
import {DynamicPageService} from "@iw-shop/dynamic-page/services/dynamic-page.service";

@Injectable({
    providedIn: 'root'
})
export class GlobalService {

    protected dynamicPageLinks: GlobalState['dynamicPageLinks'] = []
    protected visibilityGroups: string[] = []
    protected groups: GlobalState['groups'] = []


    constructor(
        private store: Store<AppState>,
        private articleService: ArticleService,
        private configService: ConfigService,
        private dynamicPageService: DynamicPageService
    ) {

    }

    protected async _setGroups() {
        let pos: number = 0;
        let filters: any = [];
        this.groups = [];
        if (this.configService.getVisibilityGroups().length > 0) {
            filters.push({fields: ['visibilityGroups'], values: this.configService.getVisibilityGroups()})
        }

        const get$ = this.articleService.get(
            {
                filters: filters,
                groups: {sortIndividual: this.configService.getDefaultSortGroup('default')}
            }
        );
        const r = await lastValueFrom(get$);
        if (r.result?.groups?.data) {
            r.result?.groups?.data.map(
                group => {
                    this.groups?.push({name: group.value, pos, groups1: []})
                    pos++;
                }
            )
        }
    }


    protected async _setGroups1(): Promise<void> {

        if (this.groups &&
            this.groups.length > 0) {
            let requests: ApiArticlesGetRequest[] = [];
            this.groups?.map(
                group => {
                    let request: ApiArticlesGetRequest = {
                        id: group.pos.toString(),
                        command: 'articles/get',
                        params: {
                            groups1: {sortIndividual: this.configService.getDefaultSortGroup1('default')},
                            filters: [{field: 'groups.groupName', value: group.name}]
                        }
                    };
                    if (this.configService.getVisibilityGroups().length > 0) {
                        request.params.filters?.push({
                            field: 'visibilityGroups',
                            value: "^(" + this.configService.getVisibilityGroups().join('|') + ")$",
                            useRegex: 1
                        })
                    }
                    requests.push(request)
                }
            );
            const batch$ = this.articleService.getBatch(requests);
            const r = await lastValueFrom(batch$);

            r.map(y => {
                if (this.groups &&
                    y.result?.groups1?.data) {
                    let group = this.groups?.filter(g => g.pos.toString() == y.id)[0], pos: number = 0;
                    y.result?.groups1?.data.map(g1 => {
                        group.groups1?.push({name: g1.value, pos});
                        pos++;
                    })
                }
            });
        }
    }

    protected async _setDynamicPageLinks() {
        const get$ = this.dynamicPageService.get({
            filters: [
                {fields: ["status"], values: ['online']},
                {fields: ["linkPositions"], values: ['top', 'foot_0', 'foot_1', 'foot_2', 'b2b_foot']}

            ],
            dynamicPages: {
                expectedData: {linkPositions: 1, uniqueName: 1, name: 1, externalLinkUrl: 1, routerLink: 1},
                sort: [{field: 'pos', direction: 1}]
            }
        });
        const r = await lastValueFrom(get$);

        if (r.result?.dynamicPages?.data) {
            r.result?.dynamicPages?.data.map(
                dp => {
                    if (dp.linkPositions) {
                        this.dynamicPageLinks?.push({
                            linkPositions: dp.linkPositions,
                            uniqueName: dp.uniqueName,
                            name: dp.name,
                            externalLinkUrl: dp.externalLinkUrl,
                            routerLink: dp.routerLink,
                        })
                    }

                }
            )
        }
    }

    async setGroups() {
        await this._setGroups().then();
        await this._setGroups1().then();
        this.store.dispatch(setGroups({groups: this.groups}));
    }


    async setDynamicPageLinks() {
        await this._setDynamicPageLinks().then();
        this.store.dispatch(setDynamicPageLinks({dynamicPageLinks: this.dynamicPageLinks}))
    }
}
